export default __webpack_public_path__ + "static/media/stamp_2@3x.fcd04584.png";